import React from 'react';

import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { IStore } from 'store/reducers';
import { AuthAgencyState } from 'store/types/authAgency';
import { AppViews } from 'endpoints';

const AuthGuard: React.FC = ({ children }) => {
  const { token } = useSelector<IStore, AuthAgencyState>((state) => state.authAgency);

  if (!token) {
    return <Redirect to={AppViews.AGENCY_LOGIN} />;
  }

  return <>{children}</>;
};

export default AuthGuard;
